angular.module('ihestiaCommonDirectives.binaryUpload', [
  'lsnBase.md5',
  'ihestiaCommonDirectives.baseUpload'
]);
